import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'
import { useNavigate } from 'react-router-dom'

import FormRender, { FormResourceType } from 'modules/forms/components/FormRender'

type Data = {
  formId: string
  resourceType: FormResourceType
  membershipId: string
  closePath?: string
  submitSuccessPath?: string
}

export const AnswerFormActivity: ActivityComponent<Data> = ({
  formId,
  membershipId,
  resourceType,
  closePath,
  submitSuccessPath,
}) => {
  const navigate = useNavigate()
  const { open, closeActivity } = useActivity()

  const handleClose = () => {
    closeActivity()

    if (closePath) {
      navigate(closePath)
    }
  }

  const handleSubmitSuccess = () => {
    closeActivity()

    if (submitSuccessPath) {
      navigate(submitSuccessPath)
    }
  }

  return (
    <FormRender
      formId={formId}
      resourceType={resourceType}
      isOpen={open}
      onClose={handleClose}
      onSubmitSuccess={handleSubmitSuccess}
      mode="answer"
      membershipId={membershipId}
    />
  )
}
